export const styles = {
  global: {
    body: {
      color: `colours.white`,
      background: `colours.purple`
    }
  }
};
